<style lang="scss">
.van-select {
    .van-dropdown-menu__bar {
        border: 1px solid #f1f1f1;
        height: 36px;
        box-shadow: none;

        .van-dropdown-menu__item {
            justify-content: space-between;
            min-width: 0;
            cursor: pointer;
            flex-wrap: nowrap;
            align-content: center;

            .van-dropdown-menu__title {
                left: 0;
                width: 95%;
            }
        }

    }
}
</style>
<template>
    <van-dropdown-menu class="van-select" direction="up">
        <van-dropdown-item :title="valueName" v-model="index" :options="options" @change="onChange" />
    </van-dropdown-menu>
</template>
<script>
export default {
    name: 'cm-select',
    components: {

    },
    model: {
        // 需要双向绑定的 props 变量名称，也就是父组件通过 v-model 与子组件双向绑定的变量
        prop: 'value',
        // 定义由 $emit 传递变量的名称
        event: 'newValue'
    },
    data() {
        return {
            step: 0,
            tabList: [],
            index: this.value,
            valueName: '请选择',
            init: 0,
        };
    },
    props: {
        value: {
            type: [Number, String],
            default: []
        },
        options: {
            type: Array,
            default: []
        }
    },
    watch: {
        value: {
            handler(v) {
                if (this.init < 2) {
                    setTimeout(() => {
                        this.index = v
                        this.init++
                    }, 100)
                }
            },
            immediate: true,
        }
    },
    mounted() {

    },
    methods: {
        onChange() {
            // console.log(this.index);
            this.options.forEach(item => {
                if (item && item.value == this.index) {
                    this.valueName = item.text
                    this.$emit('newValue', item.text)
                    this.$emit('onChange', {
                        text: item.text,
                        index: this.index
                    })
                }
            });
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/CmSelect/index.vue